/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Cargando as Cargando,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_dk_100_107(e) {
  let t = (0, ReactCompiler.c)(3),
    { variante: n, cantidad: r } = e,
    i = n === void 0 ? `filas` : n,
    a = r === void 0 ? 4 : r,
    o;
  return (
    t[0] !== a || t[1] !== i
      ? ((o = <Cargando variante={i} cantidad={a} />),
        (t[0] = a),
        (t[1] = i),
        (t[2] = o))
      : (o = t[2]),
    o
  );
}
